import lodash from "lodash";
import React from "react";
import { toggleLinkModal } from "./../_shared/link-modal/toggle-link-modal";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common";
import { BUTTON_LINK_SETTINGS_BUTTON } from ".//data-hooks";
import { getVisibleOnlyOnDesktopResolver } from "./../plugin-commons";
import { AlignmentPanel, NodeAlignmentButton } from "./../toolbars-ui";
import {
  getNodeLinkDataResolver,
  isNodeContainsLinkOrAnchorResolver
} from "./../toolbars-v3";
import { buttonsModals } from "./constants";
import ButtonSettingsModal from "./modals/SettingsModal";
const getToolbarButtons = (config, services, type) => {
  const {
    context: { isMobile }
  } = services;
  const alignment = buttonsModals.alignment[type];
  const settings = buttonsModals.settings[type];
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.LINK,
      type: "modal",
      attributes: {
        active: isNodeContainsLinkOrAnchorResolver,
        linkData: getNodeLinkDataResolver
      },
      dataHook: BUTTON_LINK_SETTINGS_BUTTON,
      tooltip: "ButtonModal_Button_Link",
      command: ({ modalService, referenceElement, attributes, tiptapEditor }) => {
        const onSave = (link) => {
          const { attrs } = attributes.selectedNode;
          tiptapEditor.chain().focus().setNodeAttrsById(attrs.id, { ...attrs, link }).run();
        };
        const onUnlink = () => {
          const { link, ...attrs } = attributes.selectedNode.attrs;
          tiptapEditor.chain().focus().setNodeAttrsById(attrs.id, attrs).run();
        };
        return toggleLinkModal({
          initialValue: attributes.linkData,
          modalService,
          onSave,
          onUnlink,
          referenceElement
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
        active: {
          id: "IS_BUTTON_SETTINGS_BUTTON_ACTIVE",
          resolve: (_, { modals }) => Boolean(modals.getModal(settings))
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        services.modals.togglePluginPanel({
          id: settings,
          isMobile: isMobile2,
          Component: ButtonSettingsModal,
          componentProps: {
            nodeId: selectedNode.attrs.id,
            settings: config,
            type,
            modalId: settings,
            referenceElement
          },
          positioning: {
            referenceElement: referenceElement.closest("[data-hook~=floating-plugin-toolbar]") ?? referenceElement,
            placement: "right-start"
          },
          onClickOutside: lodash.noop,
          focusReturnElement: referenceElement
        });
      },
      attributes: {
        active: {
          id: "IS_BUTTON_SETTINGS_BUTTON_ACTIVE",
          resolve: (_, { modals }) => Boolean(modals.getModal(settings))
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
